import { useCallback } from "react";
import { calculateCompoundInterestWithMonthlyContributions } from "../services/calculattions-service";
import { useStore } from "../store";

const useCalculateInvestmentSummary = () => {
  const { context } = useStore();
  const calculateInvestmentSummary = useCallback(() => {
    const result = calculateCompoundInterestWithMonthlyContributions(
      context.principal,
      context.annualInterestRate,
      context.monthlyDeposit,
      context.numberOfYears,
      context.managementFeesEnabled,
      context.depositFeesPercentage,
      context.accumulationFeesPercentage
    );
    
    context.investmentSummary = result.summaries;
    context.totalDepositFees = result.totalDepositFees;
    context.totalAccumulationFees = result.totalAccumulationFees;
  }, [context]);

  return calculateInvestmentSummary;
};

export default useCalculateInvestmentSummary;
